import Vue from 'vue';

const PROMO_BLOCK_WRAPPER = '.promoBlock .video__wrapper';
const VIDEO_CONTROLS_PROGRESS_BAR_CLASS = '.promoBlock__videoControls-progressBar';
const VIDEO_CONTROLS_PROGRESS_HEAD_CLASS = '.promoBlock__videoControls-progressBar-head';

function createVideoComponent(element) {
    new Vue({
        name: 'RivieraPromoVideo',
        el: element,
        data: {
            video: null,
            isShowingControls: false,
            isPlaying: true,
            isMuted: false,
            isFullscreen: false,
            isAutoplay: false,
            isLooping: false,
            hasControls: false,
            isFirstPlay: true,
            videoPlaybackPercentage: -1,
            isMouseEntered: false,
            isMouseExit: false,
            isMouseMoving: false,
            mouseMoveTimer: null,
            isVideoScrubbing: false,
            progressBarBoundingBox: null,
            progressBarHeadHalfWidth: null,
        },

        computed: {
            progressBarHeadPosition() {
                return {
                    transform: this.videoPlaybackPercentage < 0 ? 'translateX(0%)' : `translateX(${this.videoPlaybackPercentage}%)`
                }
            }
        },

        mounted() {
            this.video = this.$el.querySelector('video');
            this.isAutoplay = this.$el.dataset.autoplay === 'true';
            this.isLooping = this.$el.dataset.hasControls === 'true';
            this.hasControls = this.$el.dataset.hasLoop === 'true';

            this.isPlaying = !this.isAutoplay

            this.video.addEventListener('timeupdate', this.progressBarUpdateTicker);
            this.video.addEventListener('ended', this.videoReset);
            document.addEventListener('mouseup', this.mouseUp);

            const progressBar = this.$el.querySelector(VIDEO_CONTROLS_PROGRESS_BAR_CLASS);
            if (progressBar) {
                this.progressBarBoundingBox = this.$el.querySelector(VIDEO_CONTROLS_PROGRESS_BAR_CLASS).getBoundingClientRect();
                this.progressBarHeadHalfWidth = this.$el.querySelector(VIDEO_CONTROLS_PROGRESS_HEAD_CLASS).getBoundingClientRect().width / 2;
            }

            document.addEventListener("fullscreenchange", event => {
                var isInFullScreen =
                    (document.fullscreenElement && document.fullscreenElement !== null) ||
                    (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
                    (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
                    (document.msFullscreenElement && document.msFullscreenElement !== null) ||
                    this.video.webkitDisplayingFullscreen;

                if (!isInFullScreen) {
                    this.video.removeAttribute('controls');
                    this.isFullscreen = false;
                }
            });

            this.video.addEventListener('webkitendfullscreen', () => {
                document.querySelector('html').classList.remove('video-fullscreened');
                document.querySelector('html').classList.add('video-fullscreened-exited');
                this.isFullscreen = false;
                this.video.removeAttribute('controls', 'controls');
                this.isPlaying = this.video.paused === false;  // iOS seems to always pause video after it closes
            });

            // This event doesnt seem to fire
            this.video.addEventListener('webkitenterfullscreen', () => {
                document.querySelector('html').classList.add('video-fullscreened');
                document.querySelector('html').classList.remove('video-fullscreened-exited');
                this.isFullscreen = true;
            });

            const event = new CustomEvent('VideoVueComponentMounted');
            document.dispatchEvent(event);
        },

        beforeDestroy() {
            this.video.removeEventListener('timeupdate', this.progressBarUpdateTicker);
            this.video.removeEventListener('ended', this.videoReset);
            document.removeEventListener('mouseup', this.mouseUp);
        },

        methods: {
            initialiseControls() {
                this.isMuted = this.video.muted;
                this.isPlaying = this.video.paused === false;
            },

            videoReset() {
                // We only want to reset if the video does not automatically loop. This sets the video at the start so the user can restart video using controls.
                if (this.isLooping === false) {
                    this.isPlaying = false;
                    this.videoPlaybackPercentage = 0;
                    this.video.currentTime = 0;
                }
            },

            touchEndEvent: function (e) {
                this.isVideoScrubbing = false;
            },

            touchMoveHandler: function (e) {
                e.stopPropagation()
                const touchHandler = e.changedTouches[0]
                this.isVideoScrubbing = true;
                this.mouseMove(e, touchHandler);

            },

            getVideoPercentage() {
                return (this.video.currentTime / this.video.duration) * 100;
            },

            videoPause() {
                this.isPlaying = false;
                this.video.pause();
            },

            videoPlay() {
                this.isPlaying = true;
                this.video.play();
            },

            videoToggle() {
                if (this.isPlaying) {
                    this.videoPause();
                } else {
                    this.videoPlay();
                }
            },

            videoMute() {
                this.isMuted = true;
                this.video.muted = true;
            },

            videoUnmute() {
                this.isMuted = false;
                this.video.muted = false;
            },

            mouseUp() {
                this.isVideoScrubbing = false;
            },

            mouseEntered() {
                this.isMouseEntered = true;
                this.isMouseExit = false;
            },

            mouseExit() {
                this.isMouseEntered = false;
                this.isMouseExit = true;
            },

            mouseMove(event, isDraggingEvent) {
                const self = this;

                event.stopPropagation();
                this.isMouseMoving = true;

                if (this.isVideoScrubbing) {
                    this.progressBarClickMove(event, isDraggingEvent);
                }

                if (this.mouseMoveTimer) {
                    clearTimeout(this.mouseMoveTimer);
                }

                this.mouseMoveTimer = setTimeout(function () {
                    self.isMouseMoving = false;
                }, 1500);
            },

            toggleFullscreen() {
                var cancelFullScreen =
                    document.exitFullscreen ||
                    document.webkitExitFullscreen ||
                    document.mozCancelFullScreen ||
                    document.msExitFullscreen ||
                    this.video.webkitExitFullscreen;

                var isInFullScreen =
                    (document.fullscreenElement && document.fullscreenElement !== null) ||
                    (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
                    (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
                    (document.msFullscreenElement && document.msFullscreenElement !== null) ||
                    this.video.webkitDisplayingFullscreen;

                if (!isInFullScreen) {

                    if (document.documentElement.requestFullscreen) {
                        try {
                            this.video.requestFullscreen();
                            this.isFullscreen = true;
                        } catch (e) {
                            console.error(e);
                        }
                    } else if (document.documentElement.mozRequestFullScreen) {
                        try {
                            this.video.mozRequestFullScreen(); // Firefox
                            this.isFullscreen = true;
                        } catch (e) {
                            console.error(e);
                        }
                    } else if (document.documentElement.webkitRequestFullscreen) {

                        try {
                            this.video.webkitRequestFullscreen(); // Chrome and Safari
                            this.isFullscreen = true;
                        } catch (e) {
                            console.error(e);
                        }
                    } else if (document.documentElement.msRequestFullscreen) {
                        try {
                            this.video.msRequestFullscreen(); // IE
                            this.isFullscreen = true;
                        } catch (e) {
                            console.error(e);
                        }
                    } else if (this.video.webkitEnterFullscreen) {
                        try {
                            this.video.webkitEnterFullscreen();
                            this.isFullscreen = true;
                        } catch (e) {
                            console.error(e);
                        }
                    } else {
                        console.error("Cannot find video fullscreen support");
                    }
                    this.video.setAttribute('controls', 'controls');
                    document.querySelector('html').classList.add('video-fullscreened');
                    document.querySelector('html').classList.remove('video-fullscreened-exited');
                    if (document.body.clientWidth < 997) {
                        screen.orientation.lock(screen.orientation.type)
                    }

                } else {
                    cancelFullScreen().then(function () {

                        // Detect if video was fullscreen in iOS if so we need to state video is not playing as it always closes fullscreen and pauses video
                        if (this.video.webkitExitFullscreen) {
                            // self.state.playing = false;
                            // self.toggleContrlShow();
                        }
                    }).catch(function (err) {
                        // self.state.fullScreen = true;
                        console.error("Issue hiding video in fullscreen", err.message);
                    });
                }
            },

            progressBarClickDown(event) {
                event.stopPropagation();
                this.isVideoScrubbing = true;
                this.progressBarClickMove(event);
            },

            progressBarClickUp(event) {
                event.stopPropagation();
                this.isVideoScrubbing = false;
            },

            progressBarClickMove(event, isDraggingEvent) {
                if (!this.isVideoScrubbing) return;
                event.stopPropagation();

                // If we are dragging the scrub bar we want to ensure we clear the video contaoner mouse out timer so it doesnt hide the controls prematurely.
                if (this.mouseMoveTimer) {
                    clearTimeout(this.mouseMoveTimer);
                }

                // Calculate the offset percetnage in the bar where the users click was performed
                const trackClickPercentage = parseFloat(((isDraggingEvent ? (isDraggingEvent.clientX - this.progressBarBoundingBox.left) : event.clientX - this.progressBarBoundingBox.left - this.progressBarHeadHalfWidth) / this.progressBarBoundingBox.width).toFixed(3));

                this.progressBarSetTime(trackClickPercentage);
            },

            progressBarSetTime(percentage) {
                if (isNaN(this.video.duration) || percentage < 0) return; // If the video hasnt loaded then we cannot scrub through it.
                this.video.currentTime = (percentage * this.video.duration).toFixed(3);
            },

            progressBarUpdateTicker() {
                // Only timeupdated is reliable event so we are using this to detect when the video has first started playing
                if (this.isFirstPlay) {
                    this.initialiseControls();

                    this.isFirstPlay = false;
                }
                this.videoPlaybackPercentage = this.getVideoPercentage();
            }
        }
    });
}

function init() {
    document.querySelectorAll(PROMO_BLOCK_WRAPPER).forEach(elem => createVideoComponent(elem));
}

window.addEventListener('DOMContentLoaded', init);